import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import useSettings from "@/app/lib/features/settings/settings.hook";
import { trackGeneric } from "@/app/lib/tracking/interactions";
import { useAppDispatch } from "@/app/lib/features/redux/redux.hook";
import { closeStory } from "@/app/lib/features/story/story.slice";

const FALLBACK_LOGO = "/images/tozlu.png";

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const LogoImage = ({ width, height, className, siteLogo, siteName }: {
  width: number;
  height: number;
  className?: string;
  siteLogo: string;
  siteName: string;
}) => {
  const [imageError, setImageError] = useState(false);
  const logoSrc = imageError ? FALLBACK_LOGO : siteLogo;

  return (
    <Image
      src={logoSrc}
      alt={siteName}
      width={width}
      height={height}
      className={className}
      style={{ height: "auto" }}
      onError={() => setImageError(true)}
      priority
      unoptimized
      suppressHydrationWarning
    />
  );
};

const Logo = ({ width = 213, height = 115, className }: LogoProps) => {
  const { settings } = useSettings();
  const dispatch = useAppDispatch();

  const siteLogo = settings?.site_logo || FALLBACK_LOGO;
  const siteName = settings?.site_name || "Tozlu.com";

  const handleClick = () => {
    trackGeneric("header_logo", "click");
    dispatch(closeStory());
  };

  return (
    <Link href="/" onClick={handleClick}>
      <LogoImage
        key={siteLogo}
        width={width}
        height={height}
        className={className}
        siteLogo={siteLogo}
        siteName={siteName}
      />
    </Link>
  );
};

export default Logo;
